import { Injectable } from '@angular/core'
import { Router, Route, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, CanActivateChild, CanLoad } from '@angular/router'

import { AngularFireAuth } from 'angularfire2/auth'
import { User as FirebaseUser } from 'firebase/auth'

import { Observable } from 'rxjs/Rx'
import 'rxjs/add/operator/do'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/take'

@Injectable()
export class AuthGuard implements CanActivate, CanLoad {

  constructor(private afAuth: AngularFireAuth,
    private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const url: string = state.url
    return this.checkLogin(url)
  }

  CanActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state)
  }

  canLoad(route: Route): Observable<boolean> {
    const url = `/${route.path}`
    return this.checkLogin(url)
  }

  private checkLogin(url: string): Observable<boolean> {
    return this.afAuth.authState
      .take(1)
      .map((user: FirebaseUser) => !!user)
      .do((authenticated: boolean) => {
        if (!authenticated) {
          this.router.navigate(['/login'])
        }
      })
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/auth/auth-guard.ts